import React, { useState } from 'react';
import { Link } from 'react-router-dom'

import bg from '../assets/images/hero/bg.jpg'

import team1 from '../assets/images/team/1.jpg'
import team2 from '../assets/images/team/2.jpg'
import team3 from '../assets/images/team/3.jpg'
import team4 from '../assets/images/team/4.jpg'
import logo from '../assets/images/logo-icon-80-white.png'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'

export default function HomeBanner() {
    let [isOpen, setOpen] = useState(false);
  return (
    <>
        <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}} id='home'>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-8 order-md-1 order-2">
                        <div className="title-heading">
                            <img src={logo} className="d-md-block d-none" height="56" alt=""/>
                            <h1 className="heading text-white my-3">Making Your Business <br/> Profitable For Today</h1>
                            <p className="para-desc text-white-50">Design better and spend less time without restricting creative freedom. Combine layouts, customize everything.</p>
                            <div className="mt-4">
                                <Link to="/services" className="btn btn-primary">Explore Features <i className="mdi mdi-arrow-right"></i></Link>
                            </div>

                            <div className="mt-4 d-flex align-items-center">
                                <ul className="list-unstyled mb-0">
                                    <li className="list-inline-item"><img src={team1} className="avatar avatar-md-sm rounded-pill shadow img-thumbnail object-fit-cover" alt=""/></li>
                                    <li className="list-inline-item ms-n24"><img src={team2} className="avatar avatar-md-sm rounded-pill shadow img-thumbnail object-fit-cover" alt=""/></li>
                                    <li className="list-inline-item ms-n24"><img src={team3} className="avatar avatar-md-sm rounded-pill shadow img-thumbnail object-fit-cover" alt=""/></li>
                                    <li className="list-inline-item ms-n24"><img src={team4} className="avatar avatar-md-sm rounded-pill shadow img-thumbnail object-fit-cover" alt=""/></li>
                                </ul>

                                <Link to="/contactus" className="text-white ms-3 fw-medium">Join Eloza Community <i className="mdi mdi-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-4 order-md-2 order-1">
                        <div className="d-md-flex justify-content-center">
                            <Link to="#!" onClick={() => setOpen(true)} className="avatar avatar-md-md rounded-pill shadow bg-white d-flex justify-content-center align-items-center lightbox">
                                <i className="mdi mdi-play mdi-24px text-primary"></i>
                            </Link>
                        </div>
                    </div>
                </div>
                    <ModalVideo
                        channel="youtube"
                        youtube={{ mute: 0, autoplay: 0 }}
                        isOpen={isOpen}
                        videoId="yba7hPeTSjk"
                        onClose={() => setOpen(false)} 
                    />
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
    </>
  )
}
